import { DragIndicatorIcon } from '@ardoq/icons';
import { DRAGGABLE_CLASS_NAME } from '../../consts';
import styled from 'styled-components';
import { colors, s8 } from '@ardoq/design-tokens';
import { type I18nLocale, t } from '@ardoq/i18n';

const DragHandleStyle = styled(DragIndicatorIcon)`
  margin-left: ${s8};
  cursor: grab;
  color: ${colors.icon};
  &:active {
    cursor: grabbing;
  }
`;

const DragButton = ({
  isSaving,
  i18nLocale,
}: {
  isSaving: boolean;
  i18nLocale: I18nLocale;
}) => {
  return (
    <DragHandleStyle
      className={DRAGGABLE_CLASS_NAME}
      data-tooltip-text={t(
        i18nLocale,
        'dashboard:widgetOptions.moveChart',
        'Move chart'
      )}
      {...(isSaving ? { style: { pointerEvents: 'none' } } : {})}
    />
  );
};

export { DragButton };
